import { Badge } from "@chakra-ui/layout";
import { useTranslation } from "react-i18next";

export const BetaBadge: React.FC = () => {
  const { t } = useTranslation(["common"]);
  return <Badge variant="beta">{t("common:beta")}</Badge>;
};
